import React, { useEffect, useState } from "react";

import { Button } from "components/Graphs/Button";

const REDIRECT_DELAY_SECONDS = 5;

interface InvitationAcceptedConfirmationProps {
  organizationName?: string;
  onContinue: () => void;
}

const InvitationAcceptedConfirmation: React.FC<
  InvitationAcceptedConfirmationProps
> = ({ organizationName, onContinue }) => {
  const [remainingSeconds, setRemainingSeconds] = useState(
    REDIRECT_DELAY_SECONDS,
  );

  useEffect(() => {
    const countdownTimer = window.setInterval(() => {
      setRemainingSeconds((seconds) => Math.max(0, seconds - 1));
    }, 1000);
    const redirectTimer = window.setTimeout(
      onContinue,
      REDIRECT_DELAY_SECONDS * 1000,
    );

    return () => {
      window.clearInterval(countdownTimer);
      window.clearTimeout(redirectTimer);
    };
  }, [onContinue]);

  return (
    <div className="flex min-h-[calc(100vh-48px)] items-center justify-center px-4 py-16">
      <div className="max-w-lg text-center">
        <h1 className="text-3xl font-normal tracking-tight text-gray-900 dark:text-white">
          You’re in! Welcome to{" "}
          {organizationName ? (
            <>
              the <span className="font-bold">{organizationName}</span>{" "}
              organization.
            </>
          ) : (
            "the organization."
          )}
        </h1>
        <p
          className="mt-3 text-base text-gray-600 dark:text-secondary"
          aria-live="polite"
        >
          Redirecting to the dashboard in {remainingSeconds} seconds.
        </p>
        <Button className="mt-6" variant="primary" onClick={onContinue}>
          Go to dashboard
        </Button>
      </div>
    </div>
  );
};

export default InvitationAcceptedConfirmation;
